import { FileCheckIcon } from 'lucide-react'
import type { CondicaoUi } from './condicao-ui'

export const abono: CondicaoUi = {
    icone: FileCheckIcon,
    parametrosIniciais: {},
}
